// Port of api/fuel/app/classes/filter/search/games/filters/query/game/version/size/weight.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'version.size.weight',
	priority: 65,
	require: function(config, filter) { return filter.version && filter.version.size && rangeActive(filter.version.size.weight, 0, 9999) },
	run: function(config, filter, data, query) {
		if (filter.version.size.weight.from > 0) query.where('v.game_version_storage_weight', '>=', filter.version.size.weight.from)
		if (filter.version.size.weight.to < 9999) query.where('v.game_version_storage_weight', '<=', filter.version.size.weight.to)
	}
}
